module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2_text"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("AT YOUR SERVICE")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_vm._v("Having some basic casserole dishes on hand will speed things up:")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" 2- to 4-cup ramekins for appetizers")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" 1-quart dishes for smaller servings")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" Shallow casseroles in oval, rectangular, square, and other shapes for vessel variety and visual interest")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" Dutch ovens with lids (averaging 3 to 6 quarts) and round soufflé dishes (at least 2 quarts)")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" One each of 8-by-8-inch, 9-by-9-inch, 13-by-9-inch, and 9-by-2-inch and/or 9-by-3-inch round baking dishes")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_vm._v("TOP TIPS")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" Make sure your dish is oven safe. This is very important to know before you stick it in the oven. Some artisan pans, or mass-produced dishes, if not marked “ovenproof,” will shatter when heated to certain high temperatures; they also might contain lead. Ask the craftsperson or store owner, or inspect the box closely to see if it’s safe for food and/or cooking—or if it’s purely just kitchen decoration.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" For fast cleanup, grease casserole pans or dishes with nonstick cooking spray.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" Avoid cooking on top and bottom oven racks. The middle of the oven is where the most even heat should be centered.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" Ovens heat differently, so check for doneness about 10 minutes before the minimum cooking time.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" If you use aluminum foil to cover a casserole, place the shiny side down so it retains, instead of deflecting, the heat.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c6ee011","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_chapter01b.vue
// module id = 87
// module chunks = 0